import { get } from 'services/api';

export const ENABLED_ACCOUNTS_URL = '/settings/allEnabledAccounts.json';

/**
 * Fetch the enabled accounts data
 */
export const getEnabledAccounts = () => get(ENABLED_ACCOUNTS_URL);
